import React, { Component } from "react";

import Swal from "sweetalert2";
import { default as ReactSelect } from "react-select";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import MobileSubHeader from "../../../components/PageHeader/MobileSubHeader";
import StringInput from "../../../components/Input/StringInput/StringInput";
import NumberInput from "../../../components/Input/NumberInput/NumberInput";

const options = [
    { value: "malaysia", label: "+60", code: "MY" },
    { value: "malaysia", label: "+60", code: "ID" },
    { value: "malaysia", label: "+60", code: "INDO" },
];
export class EditMobileNo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentMobileNo: "",
            varificationCode: "",
        };
    }

    updateMobileNumber = (e) => {
        const { t } = this.props;
        e.preventDefault();

        Swal.fire({
            iconHtml: '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">',
            icon: "success",
            title: t('global.success'),
            text: t('validation.sucess-update-mobile'),
            showConfirmButton: true,
            customClass: {
                container: "swal-mobile-container sucess",
                icon: "swal-success-icon",
                confirmButton: "w-75",
            },
        });

        // Swal.fire({
        //   iconHtml: '<img src="https://api.iconify.design/mdi:close.svg?color=%23ffffff">',
        //   icon: "error",
        //   title: "Failed",
        //   text: "We have encountered a system issue, sorry for the inconvenience caused. Please try it again.",
        //   showConfirmButton: true,
        //   confirmButtonText: "Try Again",
        //   showCancelButton: true,
        //   customClass: {
        //     container: "swal-mobile-container failed",
        //     icon: "swal-failed-icon",
        //     confirmButton: "w-75",
        //   },
        // });

        // Swal.fire({
        //   iconHtml: '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">',
        //   icon: "info",
        //   title: "Sorry",
        //   text: "Invalid Code. Please try again",
        //   confirmButtonText: "OK",
        //   customClass: {
        //     container: "swal-mobile-container sorry",
        //     icon: "swal-sorry-icon",
        //     confirmButton: "w-75",
        //   },
        // });
    };

    imageImport = (r) => {
        let images = {};
        r.keys().map((item, index) => {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    };

    handleChange = (selectedOption) => {
        this.setState({ selectedOption }, () => console.log(`Option selected:`, this.state.selectedOption));
    };

    render() {
        const { t } = this.props;
        const flags = this.imageImport(require.context("../../../assets/images/flags/", false, /\.(png|jpe?g|svg|webp)$/));

        return (
            <section className="verification-m-section pf-m-dashboard on-top d-block pe-auto">
                <MobileSubHeader className="bg-white" closeModalHandler={this.props.backToPersonalDetails} header={t("profile.mobile-number-verification")} style={{ justifyContent: "unset" }} />

                <form className="forms-col needs-validation my-3" noValidate onSubmit={(e) => this.props.verifyOtpHandler(e)}>
                    <div className="pd-form-m-col">
                        <div className="input-group-col">
                            <label className="col-form-label p-0 m-0">{t("profile.mobile-number")}</label>
                            <div className="input-group left has-validation pb-3">
                                <ReactSelect
                                    classNamePrefix="react-select"
                                    defaultValue={this.props.countryArry[0]}
                                    // value={this.state.selectedOption}
                                    onChange={this.handleChange}
                                    options={this.props.countryArry}
                                    formatOptionLabel={(item) => (
                                        <>
                                            <img src={flags[`${item.code}.webp`]} alt={item.image} />
                                            <p>{item.label}</p>
                                        </>
                                    )}
                                />

                                <StringInput
                                    className={`${this.props.errorMsg.contact_no && "was-validated is-invalid"}`}
                                    type="text"
                                    placeholder={t("profile.mobile-phone-no")}
                                    name="verificationMobileNo"
                                    defaultValue=""
                                    value={this.props.currentMobileNo}
                                    onChange={(e) => this.props.enterMobileNumber(e)}
                                    minLength={this.props.contactNoMinLimits}
                                    maxLength={this.props.contactNoMaxLimits}
                                    minLengthMessage={t("validation.minLength", { 0: this.props.contactNoMinLimits })}
                                    maxLengthMessage={t("validation.maxLength", { 0: this.props.contactNoMaxLimits })}
                                    required
                                    requiredMessage={t("validation.required")}
                                    errorMsg={this.props.errorMsg.contact_no || ""}
                                    formError={this.props.formError}
                                />
                            </div>

                            <div className="pt-3 border-top">
                                <label className="col-form-label p-0 m-0">{t("profile.verification-code")}</label>
                                <div className="verificate-m-input">
                                  <NumberInput
                                    className={`form-control forget-pwd-mobile ${this.props.errorMsg.otp_code && "was-validated is-invalid"}`}
                                    // className={`form-control forget-pwd-mobile`}
                                            type="number"
                                            onChange={(e) => this.props.enterMobileVarificationCode(e)}
                                            placeholder={t("profile.enter-verification-code")}
                                            errorMsg={this.props.errorMsg.otp_code || ""}
                                            formError={this.props.formError}
                                            required
                                            requiredMessage={t("validation.required")}
                                            value={this.props.mobileVarificationCode}
                                        />
                                    {this.props.generateOTPStatus && this.props.check_sending_sms_status ? (
                                        <>
                                            {this.props.resendOTPCountDownTimer && <small>{this.props.resendOTPCountDownTimer}</small>}
                                            <button
                                                className="btn btn-blue"
                                                type="button"
                                                onClick={this.props.resendOTPHandler}
                                                disabled={this.props.resend_otp_button_disabled === true ? true : false}
                                            >
                                                {t("forgot-password.request")}
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <button
                                                className="btn btn-blue"
                                                type="button"
                                                onClick={this.props.generateOTPHandler}
                                            >
                                                {t("forgot-password.request")}
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        <button
                            className="btn btn-gradient-blue mx-3"
                            type="submit"
                            disabled={this.props.mobileVarificationCode === "" ? true : false}
                        >
                            {t("global.submit")}
                        </button>
                        {/* <p className="notice-desc">
                            For your safety, the information cannot be modified after confirmation, please contact
                            <Link to={{ pathname: "/" }}> customer service </Link> if you need help.
                        </p> */}
                    </div>
                </form>
            </section>
        );
    }
}

export default (withNamespaces(EditMobileNo));
